/**
 * Character limits for the Add / Modify Customs Broker form.
 *
 * Without them a customer can paste text of any length, and the saved value
 * then has nowhere to go on the broker card. The numbers are generous enough
 * for any real broker while keeping a saved broker readable.
 */
export const brokersFieldLimits = {
  businessName: 100,
  accountNumber: 45,
  addressLine: 100,
  addressLine2: 100,
  city: 50,
  // The validator accepts only "A1A 1A1" (7 with the space) or a 5-digit US
  // ZIP, so 7 is the longest value that can ever be valid.
  postalCode: 7,
  contactName: 100,
  emailAddress: 100,
} as const;
